import { useEffect } from "react";
import Lenis from "lenis";
import { SiteHeader } from "@/components/site/SiteHeader";
import { HeroSection } from "@/components/site/HeroSection";
import { MissionSection, MarqueeSection } from "@/components/site/MissionSection";
import { ChallengeSection } from "@/components/site/ChallengeSection";
import { PillarsSection, ScholarPathwaySection } from "@/components/site/PillarsSection";
import { FounderSection, MidCTA } from "@/components/site/FounderSection";
import { ApplySection } from "@/components/site/ApplySection";
import { ContactSection } from "@/components/site/ContactSection";
import { SiteFooter } from "@/components/site/SiteFooter";
import { siteConfig } from "@/data/siteConfig";
import { scrollToId } from "@/components/site/shared";
import { ArrowRight } from "lucide-react";

const MobileStickyCTA = () => (
  <div data-testid="mobile-sticky-cta" className="fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-navy/95 backdrop-blur-lg p-3 lg:hidden">
    <button
      onClick={() => scrollToId("#apply")}
      className="flex w-full items-center justify-center gap-2 bg-gold py-3.5 text-sm font-semibold text-navy"
    >
      {siteConfig.primaryCta} <ArrowRight size={16} />
    </button>
  </div>
);

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="bg-cream min-h-screen">
      <SiteHeader />
      <main>
        <HeroSection />
        <MarqueeSection />
        <MissionSection />
        <ChallengeSection />
        <PillarsSection />
        <MidCTA />
        <ScholarPathwaySection />
        <FounderSection />
        <ApplySection />
        <ContactSection />
      </main>
      <SiteFooter />
      <MobileStickyCTA />
    </div>
  );
}
